import React, {Component} from 'react';
import {Alert as Alert2, Button, Col, Input, Label, Row} from "reactstrap";
import Select from "../../local_node_modules/react-select";
import moment from "moment";
import DefaultModal from "../invoice/DefaultModal";

import "./chat.css";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import ImageBox from "./ImageBox";
import {Modal} from "react-bootstrap";

class CustomerRequestMessageModal extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.inputFile = React.createRef();
        this.state = {
            requestMessageLines: [],
            loading: false,
            newMessage: "",
            services: [],
            subjectType: "",
            subject: "",
            requestForm: this.props.selected,
            section: this.props.section,
            acceptedFile: null,
            imageURI: null,
            savedImagePath: '',
            assignees: [],
            isDisabled: false,
            messageType: "",
            prDay:""

        }
        this.messageType = "";
        this.previousDay = "";
        this.fetchData = this.fetchData.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.fetchService = this.fetchService.bind(this);
        this.onRequestChange = this.onRequestChange.bind(this);
        this.calculateTime = this.calculateTime.bind(this);
        this.goDetail = this.goDetail.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.fileSelected = this.fileSelected.bind(this);
        this.closeImage = this.closeImage.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
        this.fetchAssignees = this.fetchAssignees.bind(this);
        this.viewValue = this.viewValue.bind(this);
        this.showMessageInfo = this.showMessageInfo.bind(this);
        this.showDay = this.showDay.bind(this);
        /*this.renderImageBox = this.renderImageBox.bind(this);*/
    }

    componentDidMount() {
        if (this.state.section === "message") {
            this.fetchData(this.props.selected.recordId);
            this.scrollToBottom();
            this.setState({requestForm: this.props.selected})
        } else {
            this.fetchService();
            this.fetchAssignees();
        }
        this.fetchService();
        this.fetchAssignees();
    }

    scrollToBottom() {
        if (this.state.section === "message") {
            const node = this.myRef.current;
            node.scrollTo(0, node.scrollHeight);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.scrollToBottom();
    }

    fetchService() {
        let self = this;
        let params = {
            url: "/requestForm/getServices",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let services = response.data;
                services.push({ublCode: "Diğer", ublName: "DIGER"});
                self.setState({services});
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({loading: false});
        });
    }

    fetchData(requestId) {
        let self = this;
        let params = {
            url: '/requestForm/getMessageLine' + '?requestId=' + requestId,
            method: "get"
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                self.setState({
                    requestMessageLines: response.data,
                    loading: false,
                });

            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    calculateTime(data, type) {
        let date = moment(data);
        let hour = date.hour().toString().length === 1 ? "0" + date.hour().toString() : date.hour().toString();
        let minute = date.minute().toString().length === 1 ? "0" + date.minute().toString() : date.minute().toString();
        let diffValue = moment().diff(date.format('YYYY MM DD'), "days");
        let diff = "";
        let time = "";
        if (diffValue === 0)
            diff = "Bugün";
        else if (diffValue === 1)
            diff = "Dün"
        else
            diff = date.format('YYYY MM DD').replaceAll(" ","/");
            /*diff = diffValue.toString() + " Gün Önce";*/


        if (type === "hour")
            time = hour + ":" + minute
        else {
            time = diff;
        }
        return time;
    }

    renderMessages(message, i) {
        let self = this;
        let requestForm = self.state.requestForm;
        let name = message.userId === requestForm.senderId ? requestForm.senderUsername : 'Kolaysoft';
        let day = self.calculateTime(message.createdTime, "day");
        const isShowDay = self.showDay(day,i);
        if (this.props.currentUser.vknTckn === message.vknTckn) {
            let showDetail = self.showMessageInfo("me");
            return (
                message.type === "message" ?
                    <li key={i} className="me" style={!showDetail ? {padding: "0 30px"} : {}}>
                        {
                             isShowDay &&
                            <div className="date">
                                <div className="area">{day}</div>
                            </div>
                        }
                        <div className="entete">
                            {/* <h3>{this.calculateTime(message.createdTime)}</h3>
                        {
                            self.showMessageInfo("me")&&
                            <h2 style={{marginLeft: "5px"}}>{name}</h2>
                        }*/}

                            <span className="status blue"></span>
                        </div>
                        {
                            (showDetail || isShowDay) &&
                            <div className="triangle"></div>
                        }
                        <div className="message">
                            <div className="col">
                                <div className="row">
                                    <p>
                                        {message.message}

                                    </p>
                                    <span>{this.calculateTime(message.createdTime, "hour")}</span>
                                </div>
                            </div>


                        </div>
                    </li> :
                    <li key={i} className="me">
                        {/*{self.showMessageInfo("me")}*/}
                        <div className="entete">
                            {/*<h3>{this.calculateTime(message.createdTime)}</h3>
                            <h2 style={{marginLeft: "5px"}}>{name}</h2>
                            <span className="status blue"></span>*/}
                        </div>

                        <ImageBox path={message.imagePath}/>

                    </li>

            )
        } else {
            let showDetail = self.showMessageInfo("you");
            return (
                message.type === "message" ?
                    <li key={i} className="you" style={!showDetail ? {padding: "0 30px"} : {}}>
                        {
                            isShowDay &&
                            <div className="date">
                                <div className="area">{day}</div>
                            </div>
                        }
                        <div className="entete">
                            {/*<span className="status green"></span>
                        {self.showMessageInfo("you")&&
                        <h2 style={{marginRight: "5px"}}>{name}</h2>
                        }
                        <h3>{this.calculateTime(message.createdTime)}</h3>*/}
                        </div>
                        {
                            (showDetail || isShowDay) &&
                            <div className="triangle"></div>
                        }

                        <div className="message">
                            <div className="col">
                                <div className="row">
                                    <p>
                                        {message.message}

                                    </p>
                                    <span>{this.calculateTime(message.createdTime, "hour")}</span>
                                </div>
                            </div>

                        </div>
                    </li> :
                    <li key={i} className="you">
                        {/*{self.showMessageInfo("you")}*/}
                        <div className="entete">
                            {/*<span className="status green"></span>
                            <h2 style={{marginRight: "5px"}}>{name}</h2>
                            <h3>{this.calculateTime(message.createdTime)}</h3>*/}
                        </div>

                        <ImageBox path={message.imagePath}/>


                    </li>
            )
        }
    }

    sendMessage(type) {
        let self = this;
        let message = self.state.newMessage;
        if (type === "message" && message.length === 0) {
            Alert.error('İçeriği boş mesaj gönderilemez.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }
        let requestFormId = self.state.requestForm.recordId;
        let requestForm = self.state.requestForm;
        let currentUser = this.props.currentUser;

        if (!(requestForm.receiverId) && requestForm.senderId !== currentUser.id) {
            requestForm.receiverId = currentUser.id;
            requestForm.receiverUsername = currentUser.username;
        }
        let requestMessage = null;
        if (type === "message") {
            requestMessage = {
                requestForm: {recordId: requestFormId},
                message: message,
                type: "message",
                isRead:false
            }
        } else {
            requestMessage = {
                requestForm: {recordId: requestFormId},
                message: message,
                imagePath: self.state.savedImagePath,
                type: "image",
                isRead:false
            }
        }

        let params = {
            url: '/requestForm/addMessage',
            method: "post",
            data: requestMessage
        };
        /*self.setState({loading: true});*/
        self.setState({isDisabled:true});
        request(params)
            .then(function (response) {
                self.setState({newMessage: ""});
                self.fetchData(requestFormId);
                self.setState({isDisabled:false});
            }).catch(function (error) {
            self.setState({isDisabled:false});
            showAxiosError(error);
        });

    }

    handleMessage(e) {
        let self = this;
        let value = e.target.value;
        self.setState({newMessage: value});
    }


    onRequestChange(data) {
        let self = this;
        let requestForm = self.state.requestForm;
        requestForm[data.name] = data.value;
        self.setState({requestForm});
    }

    goDetail() {
        let self = this;
        self.setState({section: "detail"});
    }

    handleFileSelect() {
        let self = this;
        self.inputFile.current.click();
    }

    fileSelected(event) {
        let self = this;
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        const enableFileTypes = [
            "image/apng",
            "image/bmp",
            "image/gif",
            "image/jpeg",
            "image/pjpeg",
            "image/png",
            "image/svg+xml",
            "image/tiff",
            "image/webp",
            "image/x-icon"
        ]
        if (files && enableFileTypes.includes(files[0].type)) {
            self.setState({acceptedFile: files[0]});
            let reader = new FileReader();
            reader.onload = function (e) {
                this.setState({imageURI: e.target.result, section: "preview"});
            }.bind(this);
            reader.readAsDataURL(files[0]);
        } else {
            Alert.error('"image/apng",\n' +
                '            "image/bmp",\n' +
                '            "image/gif",\n' +
                '            "image/jpeg",\n' +
                '            "image/pjpeg",\n' +
                '            "image/png",\n' +
                '            "image/svg+xml",\n' +
                '            "image/tiff",\n' +
                '            "image/webp",\n' +
                '            "image/x-icon" tipleri dışında dosya yükleyemezsiniz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    closeImage() {
        let self = this;
        self.setState(
            {
                section: "message",
                acceptedFile: null,
                imageURI: null
            });
        this.inputFile.current.value = '';
    }

    uploadImage() {
        let self = this;
        let file = self.state.acceptedFile;
        const formData = new FormData();
        formData.append('uploadFile', file);
        formData.append('requestId',self.props.selected.recordId);
        let params = {
            url: '/requestForm/uploadImage',
            method: "post",
            data: formData
        };
        request(params).then(function (response) {
            self.setState({savedImagePath: response.data}, () => self.sendMessage("image"));
        }).catch(function (error) {

            showAxiosError(error);
        });
        self.closeImage();
    }

    fetchAssignees() {
        let self = this;
        let params = {
            url: "/user/getUserBySelectedRole",
            method: "get",
        };
        request(params).then(function (response) {
            self.setState({assignees: response.data});
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    viewValue(value) {
        let self = this;
        let assignees = self.state.assignees;
        let found = assignees.find(item => item.recordId === value);
        if (found) {
            let name = found.firstName + " " + found.lastName;
            return name;
        }
    }

    showMessageInfo(type) {
        let self = this;
        let messageType = self.messageType;


        if (type === self.messageType) {
            return false;
        } else if(self.messageType === ""){
            self.messageType = type
            return true;
        }
        else {
            self.messageType = type;
            return true
        }

    }

    showDay(day,index) {
        let self = this;
        if(index === 0)
            return true;
        else if(day === self.calculateTime(self.state.requestMessageLines[index - 1].createdTime,"day"))
            return false;
        else
            return true;
    }

    render() {
        let requestForm = this.state.requestForm;
        return (
            <div id="requestForm">
                <Modal
                    show={this.props.modal}
                    onHide={this.props.close}
                    dialogClassName="modal-902w"
                    contentClassName="rqForm-modal-content"
                >
                    <Modal.Header className="modalHeadSection" closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {this.state.requestForm.subjectType + " - " + this.state.requestForm.subject}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.section === "detail" ?
                            (<Col sm="12">

                                <Row>
                                    <Col sm="3" lg="2">
                                        <Label>Konu Tipi:</Label>
                                    </Col>
                                    <Col sm="9" lg="4">
                                        <Select
                                            clearable={false}
                                            placeholder="Konu Seçiniz.."
                                            noResultsText="Kayıt Bulunamadı.."
                                            className="select-control"
                                            value={this.state.requestForm.subjectType}
                                            onChange={(e) => e && this.onRequestChange({
                                                name: "subjectType",
                                                value: e.value
                                            })}
                                            options={this.state.services.map(service => ({
                                                value: service.ublName,
                                                label: service.ublCode
                                            }))}
                                        />
                                    </Col>
                                    {this.props.currentUser.vknTckn === '5750464002' &&

                                    <Col sm="3" lg="2">
                                        <Label>Atanan Kişi:</Label>
                                    </Col>}
                                    {this.props.currentUser.vknTckn === '5750464002' &&
                                    <Col sm="9" lg="4">
                                        <Select
                                            clearable={false}
                                            placeholder="Kişi Seçiniz.."
                                            noResultsText="Kayıt Bulunamadı.."
                                            className="select-control"
                                            value={requestForm.receiverId}
                                            onChange={(e) => e && this.onRequestChange({
                                                name: "receiverId",
                                                value: e.value
                                            })}
                                            options={this.state.assignees.map(assignee => ({
                                                value: assignee.recordId,
                                                label: assignee.firstName + " " + assignee.lastName
                                            }))}
                                        />
                                    </Col>
                                    }
                                    {/*<Col sm="12" lg="9">
                                <Label>Konu:</Label>
                                <Input type="text"
                                       autoComplete={"false"}
                                       value={this.state.requestForm.subject}
                                       onChange={(e) => this.onRequestChange({
                                           name: "subject",
                                           value: e.target.value
                                       })}/>
                            </Col>*/}
                                </Row>
                                <Row>
                                    <Col sm="3" lg="2">
                                        <Label>Konu:</Label>
                                    </Col>
                                    <Col sm="9" lg="10">
                                        <Input type="text"
                                               autoComplete={"false"}
                                               value={this.state.requestForm.subject}
                                               onChange={(e) => this.onRequestChange({
                                                   name: "subject",
                                                   value: e.target.value
                                               })}/>
                                    </Col>


                                </Row>

                            </Col>)
                            :
                            (<Col sm="12">
                                <Row>
                                    <main>
                                        {this.state.imageURI ?
                                            <Row className="d-flex justify-content-center">
                                                <div style={{padding: "0px 2px"}}>
                                                    <button className="close-button" onClick={() => this.closeImage()}>
                                                        {/*<i className="fas fa-times-circle"/>*/}
                                                        <i className="far fa-times-circle"></i>
                                                    </button>
                                                    <button className="upload-button"
                                                            onClick={() => this.uploadImage()}>
                                                        <i style={{fontSize: "17px"}}
                                                           className="fas fa-cloud-upload-alt"></i> Yükle
                                                    </button>
                                                    <img src={this.state.imageURI}></img>
                                                </div>
                                            </Row>


                                            :
                                            <ul ref={this.myRef} id="chat">
                                                {
                                                    this.state.requestMessageLines.map((message, i) => (
                                                        this.renderMessages(message, i)
                                                    ))
                                                }
                                            </ul>
                                        }
                                    </main>
                                </Row>
                            </Col>)
                        }
                    </Modal.Body>
                    <Modal.Footer className="requestForm-footer">
                        {/*<div>
                            <img style={{width: "180px"}}
                                 src="https://www.kolaysoft.com.tr/wp-content/uploads/2019/10/kolay_main_logo.png"/>
                        </div>*/}
                        {this.state.requestForm.status === "CLOSED" ?

                                <div className="col" style={{display:"block"}}>
                                    <div className="d-flex justify-content-center bg-transparent edit-col mb-2">
                                        <h6 className="mr-auto ml-auto" style={{margin:"0",color:"red"}}>Bu talep kapatılmıştır.</h6>
                                    </div>
                                    {this.props.currentUser.vknTckn !== '5750464002' &&
                                    <div className="d-flex justify-content-center bg-transparent edit-col">
                                        <Button onClick={this.props.messageToCreate} className="mr-auto ml-auto">Yeni Talep Oluştur</Button>
                                    </div>
                                    }

                                </div>


                            :
                            <div className="col">
                                <div className="col-12 row d-flex justify-content-center bg-transparent edit-col">
                                    <div className="col-10">
                                        <textarea className="requestForm-textarea" onChange={(e) => this.handleMessage(e)}
                                                  placeholder="Mesajınızı yazınız"
                                                  rows="3" cols="70"
                                                  maxLength="300"
                                                  value={this.state.newMessage}></textarea>
                                    </div>

                                    <div className='ml-1 col-1 d-flex ' style={{height: '100%'}}>
                                        <div className='pl-1'>
                                            <button disabled={this.state.isDisabled} onClick={() => this.sendMessage("message")}
                                                    className="send-button btn mb-auto "
                                            ><i style={{fontSize: "25px"}}
                                                className="fas fa-paper-plane"/>
                                            </button>
                                        </div>
                                        <div
                                            className='d-flex  justify-content-between align-items-end mt-auto mb-auto pl-3 pr-3'>
                                            <input ref={this.inputFile}
                                                   type="file"
                                                   style={{
                                                       display: 'block',
                                                       visibility: 'hidden',
                                                       width: '0px',
                                                       height: '0px'
                                                   }}
                                                   onChange={this.fileSelected}/>
                                            <button className="btn mb-1 mr-5" style={{
                                                margin: 0,
                                                fontSize: "12px",
                                                padding: 0,
                                                background: 'transparent',
                                                border: 'none'
                                            }} onClick={() => this.handleFileSelect()}>
                                                <i className="fas fa-image"
                                                   style={{fontSize: "25px", color: 'mediumseagreen'}}/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Footer>

                </Modal>
            </div>
        );
    }
}

export default CustomerRequestMessageModal;